import { Modal } from "antd"
import { useState, useEffect } from "react"
import SearchableDropdown from "../../components/SearchableDropdown"

import "./FormDocuSignRequest.css"
import FormRenderer from "./FormRenderer"
import { createZipFile, downloadFile } from "../utils/Utilities"

const FormDocuSignPreview = ({ documents, openModal, handleModalOpen }) => {

    const [selectedDocument, setSelectedDocument] = useState(null)

    useEffect(() => {
        if(documents?.length > 0) {
            setSelectedDocument(documents[0])
        }
    }, [documents])

    const getDocumentOptions = () => {
        return documents?.map(document => ({ id: document, name: document.fileName }))
    }

    const handleDocumentChange = (document) => {
        setSelectedDocument(document)
    }

    const handleDownloadForm = async () => {
        const zipBlob = await createZipFile(documents)
        downloadFile(zipBlob, "forms.zip")
    }

    return (
        <Modal className="form-docusign-request-modal" width="100%" open={openModal} onCancel={() => handleModalOpen(false)} footer={[]}>
            <div className="forms-header">
                <div className='top-header'>
                    <header>Documents Preview</header>
                </div>
            </div>
            <div className="form-preview-container">
                <div className="form-preview-type-selector">
                    <div><h3 className="header">Document</h3></div>
                    <div className="search-dropdown">
                        <SearchableDropdown
                            options={getDocumentOptions()}
                            label="name"
                            id="id"
                            selectedVal={selectedDocument?.fileName}
                            placeholderVal={"Select Document..."}
                            handleChange={(val, id) => handleDocumentChange(id)}
                        />
                    </div>
                </div>
                <div className="form-preview">
                    {selectedDocument && 
                        <FormRenderer
                            pdfData={selectedDocument.content}
                            formName={selectedDocument.fileName}
                            handleDownloadForm={handleDownloadForm}
                        />
                    }
                </div>
            </div>
        </Modal>
    )
}

export default FormDocuSignPreview